import React, {
    PureComponent
} from 'react';
import {
    Cascader
} from 'antd';
import generateOptions from '../../components/dataEntry/areaPickerOption';
// import functionTools from "../../utils/Tool";

const CityDataHoc = (ParentCom) => {
    return class extends PureComponent {
        constructor(props) {
            super(props);
        }

        childItem(placeholder, name, isPickArea, isChangeSelect, customStyle) {
           // console.log('--------this------------', this);
           const options = generateOptions(isPickArea);
            let isChange = isChangeSelect ? true : false;
            const parentItem = class extends PureComponent {
                render() {
                    const props = this.props;
                    const inputStyle = customStyle ? customStyle : {width: '100%'};
                    return <Cascader {...props}
                                     options={options}
                                     popupClassName={'allshow'}
                                     notFoundContent={'暂无选项'}
                                     changeOnSelect={isChange} style={inputStyle}
                                     placeholder={placeholder}/>
                }
            };
            return parentItem;
        }


        format(coreVal) {
            if (coreVal) {
                return coreVal.length === 1 ? coreVal[0] : coreVal.length === 2 ? coreVal[1] : coreVal[2];
            }
        }

        componentDidMount() {
            console.log('--cityData--', this.props.getInstance);
            if (this.props.getInstance && typeof this.props.getInstance === 'function') {
                this.props.getInstance(this.ctx);
            }
        }

        render() {
            const items = [this.childItem.bind(this)];
            // getInstance 获取子组件上下文
            return <ParentCom {...this.props} cityDataFilter={items} format={this.format}
                              getInstance={(ctx) => {
                                  this.ctx = ctx
                              }}/>;
        }
    };
}

export default CityDataHoc;


// WEBPACK FOOTER //
// ./src/AntD/hoc/form/cityDataHoc.js